var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSection3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M30.2189 10.5437C29.6253 10.1697 28.8957 10.1367 28.2738 10.4531L26.1743 11.5131C25.3979 11.9043 24.9163 12.6953 24.9163 13.5755V21.8396C24.9163 22.7198 25.3979 23.5094 26.1743 23.9035L28.2724 24.9621C28.5571 25.1088 28.8617 25.1792 29.1663 25.1792C29.5318 25.1792 29.8945 25.0757 30.2189 24.8729C30.8125 24.5004 31.1667 23.8546 31.1667 23.147V12.271C31.1667 11.5634 30.8125 10.9176 30.2189 10.5437",
    fill: "#136BFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8655 28.3334H8.66006C5.22886 28.3334 2.83325 25.9675 2.83325 22.5804V12.8363C2.83325 9.44784 5.22886 7.08337 8.66006 7.08337H16.8655C20.2967 7.08337 22.6923 9.44784 22.6923 12.8363V22.5804C22.6923 25.9675 20.2967 28.3334 16.8655 28.3334",
    fill: "#136BFE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSection3);
export default __webpack_public_path__ + "static/media/section-3.785a30eb9bbed329bdf27344f2479546.svg";
export { ForwardRef as ReactComponent };